const state = {
  /**
   * 显示状态
   */
  previewVisible: false,
  mediaPreviewOption: {
    /**
     * 预览类型
     *  - image 图片
     *  - video 视频
     *  - audio 音频
     */
    previewType: 'image',
    /**
     * 预览下标
     */
    initialIndex: 0,
    /**
     * 预览地址
     *  - 图片、音频 [xx, xxx]
     *  - 视频 [{poster: xx, src: ''}]
     */
    previewSrcList: []
  }
}

const mutations = {
  OPEN_MEDIA_VIEWER(state, payload) {
    state.mediaPreviewOption = {
      ...state.mediaPreviewOption,
      ...payload
    }
    state.previewVisible = true
  },

  CLOSE_MEDIA_VIEWER(state) {
    state.previewVisible = false
    state.mediaPreviewOption.initialIndex = 0
  }
}

export default {
  namespaced: true,
  state,
  mutations
}